import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="turnstile"
//
// By default the widget renders as soon as this controller connects — fine on
// a normal page, where the element is visible right away. Set lazyValue when
// the element starts out hidden (e.g. inside a closed <dialog>): the widget
// won't execute while display:none, so rendering is deferred to whoever makes
// it visible (e.g. modal#open dispatching "modal:open").
//
// That listener is wired up here in JS, NOT via a data-action attribute on
// this element. This element is also what we hand to window.turnstile.render()
// as the container, and Cloudflare reads its OWN data-* attributes off that
// same element (sitekey, theme, action, …) as optional render parameters. A
// data-action="modal:open@window->turnstile#render" attribute collides with
// Turnstile's "action" parameter — Turnstile tries to parse the Stimulus
// action descriptor as its action string, rejects it, and throws
// TurnstileError instead of rendering. Do not "simplify" this back to
// data-action.
export default class extends Controller {
	static values = { sitekey: String, lazy: Boolean };

	connect() {
		if (this.lazyValue) {
			this.renderOnModalOpen = () => this.render();
			window.addEventListener("modal:open", this.renderOnModalOpen);
		} else {
			this.render();
		}
	}

	disconnect() {
		if (this.renderOnModalOpen) {
			window.removeEventListener("modal:open", this.renderOnModalOpen);
			this.renderOnModalOpen = null;
		}

		if (this.widgetId != null && window.turnstile) {
			window.turnstile.remove(this.widgetId);
			this.widgetId = null;
		}
	}

	render() {
		if (this.widgetId != null) return;

		if (window.turnstile) {
			this.widgetId = window.turnstile.render(this.element, {
				sitekey: this.sitekeyValue,
				theme: "light",
				language: "pt-br",
			});
		} else {
			setTimeout(() => this.render(), 200);
		}
	}
}
